import { ButtonGroup, Card, CardContent, CardProps } from '@mui/material';
import SectionHeader from 'components/ui/typography/SectionHeader';
import { PropsWithChildren } from 'react';

export interface EnhancedCardProps extends PropsWithChildren, Omit<CardProps, 'title'> {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  buttons?: React.ReactNode;
}

export const EnhancedCard = ({
  title,
  subtitle,
  buttons,
  children,
  sx,
  ...props
}: EnhancedCardProps) => {
  const hasHeader = Boolean(title || subtitle);
  return (
    <Card
      variant="outlined"
      {...props}
      sx={{
        mb: 3,
        borderRadius: 2,
        borderColor: 'divider',
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.04)',
        ...sx
      }}>
      <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 3, p: { xs: 2, sm: 3 } }}>
        <div className="flex justify-between">
          {hasHeader && <SectionHeader title={title} subtitle={subtitle} />}
          <br />
          {buttons && (
            <ButtonGroup
              className="px-2"
              // sx={{
              //   '& .MuiButton-root': {
              //     textTransform: 'none',

              //     fontFamily: 'Roboto, sans-serif',
              //     fontWeight: 500,
              //     fontSize: '14px',
              //     lineHeight: '1.2', // 120%
              //     letterSpacing: '0em',
              //     color: '#ffffff',
              //     height: '40px',
              //     boxShadow: 'none',
              //     whiteSpace: 'nowrap',
              //     minWidth: 'max-content',
              //     transition: 'all 0.2s ease-in-out',

              //     '&.MuiButton-outlined': {
              //       backgroundColor: '#1d70b8',
              //       color: '#ffffff',
              //       borderRadius: 2,
              //       '&:hover': {
              //         backgroundColor: '#155a96',
              //         boxShadow: 'none'
              //       },
              //       '& .MuiButton-startIcon': {
              //         fontSize: 'small',
              //         color: '#ffffff',
              //         marginRight: '6px'
              //       },
              //       '& .MuiTypography-root': {
              //         color: '#ffffff'
              //       }
              //     },

              //     '&.MuiButton-text': {
              //       backgroundColor: 'transparent',
              //       borderRadius: 0,
              //       '&:hover': {
              //         backgroundColor: 'rgba(0, 109, 176, 0.04)',
              //         textDecoration: 'underline'
              //       },
              //       '& .MuiButton-startIcon': {
              //         color: '#006DB0'
              //       },
              //       '& .MuiTypography-root': {
              //         color: '#006DB0'
              //       }
              //     },

              //     '&.MuiButton-contained': {
              //       backgroundColor: '#1d70b8',
              //       color: '#ffffff',
              //       borderRadius: 2,
              //       border: '1px solid #1d70b8',
              //       '&:hover': {
              //         backgroundColor: '#155a96',
              //         borderColor: '#155a96',
              //         boxShadow: 'none'
              //       },
              //       '& .MuiButton-startIcon': {
              //         fontSize: 'small',
              //         color: '#ffffff',
              //         marginRight: '6px'
              //       },
              //       '& .MuiTypography-root': {
              //         color: '#ffffff'
              //       }
              //     }
              //   },

              //   '& .MuiButton-startIcon': {
              //     transition: 'color 0.2s ease-in-out',
              //     marginRight: '6px'
              //   },

              //   '& .MuiTypography-root': {
              //     fontFamily: 'Roboto, sans-serif',
              //     fontWeight: 500,
              //     fontSize: '13px',
              //     lineHeight: '1.2', // 120%
              //     letterSpacing: '0em',
              //     textTransform: 'none',
              //     color: '#ffffff'
              //   }
              // }}
            >
              {buttons}
            </ButtonGroup>
          )}
        </div>
        {children}
      </CardContent>
    </Card>
  );
};
